import { cva } from '@/styled-system/css';

export const toastRecipe = cva({
  variants: {
    isWizardView: {
      true: {
        marginRight: {
          base: 'default',
          lg: '600',
          xl: '{sizes.2600}' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change */,
        },
        '&:last-child': {
          marginBottom: '{sizes.2600} !important',
        },
      },
      false: {
        marginRight: 'default',
      },
    },
  },
});
